import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const accessingCampaignEditor = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5) > div > span > i',
  popover: {
    title: 'Accessing the Campaign Editor',
    description:
      "To manage a campaign, click the <code><i class='os-icon-more-vertical'></i></code> button. You'll see a list of available actions, including editing, cloning, and deleting.",
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const actionsMenuBtn = document.querySelector(
        '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5) > div > span > i'
      );

      if (actionsMenuBtn) {
        actionsMenuBtn.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

export const editMenuOptions = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5) > div > ul',
  popover: {
    title: 'Action Options',
    description: `
      To edit a campaign, select <strong>&quot;Edit&quot;</strong> from the dropdown menu
      <br/><br/>
      <strong>Shortcut:</strong> You can also click directly on the campaign creative to jump to the edit page.
      `,
    onNextClick: () => {
      const campaignCreative = document.querySelector('#campaigns > tbody > tr:nth-child(1) > td:nth-child(1) > div');

      if (campaignCreative) {
        campaignCreative.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
